// src/components/Footer.jsx
import { Mail, Instagram, Phone, MapPin } from "lucide-react";

function Footer() {
  const waNumber = "5527995785444";
  const waText = encodeURIComponent(
    "Olá, quero orçamento para cenografia/iluminação.\n\n" +
      "• Data do evento:\n" +
      "• Cidade/Local:\n" +
      "• Tipo de evento:\n"
  );
  const waLink = `https://wa.me/${waNumber}?text=${waText}`;

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-top">
          <img
            src="/images/logo/cenovix-logo.png"
            alt="Cenovix - Cenografia e Iluminação Cênica"
            className="footer-logo"
          />

          <div className="footer-links" aria-label="Contatos Cenovix">
           <a
  className="footer-link"
  href="https://mail.google.com/mail/?view=cm&fs=1&to=cenovixeventos@gmail.com"
  target="_blank"
  rel="noopener noreferrer"
>

              <Mail size={18} />
              <span>cenovixeventos@gmail.com</span>
            </a>

            <a
              className="footer-link"
              href="https://www.instagram.com/ceno.vix/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={18} />
              <span>@ceno.vix</span>
            </a>

            <a
              className="footer-link"
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Phone size={18} />
              <span>+55 (27) 99578-5444</span>
            </a>

            <div className="footer-location" aria-label="Localização Cenovix">
              <MapPin size={18} />
              <span>Vila Velha - ES</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Cenovix — Cenografia e Eventos</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
